import React from 'react'
import { NextModal as Modal, Text } from '@components/UI'
import { Files as FS } from '@constants'

const OversizeModal = ({ close, files }) => {
  return (
    <Modal className='oversize' title='Max file size exceeded' close={close}>
      <div>
        <Text>
          We were not able to upload following file(s) as they exceed maximum
          file size {FS.MAX_FILE_SIZE / (1024 * 1024)} MB:
        </Text>
        <ul>
          {files.map((v) => (
            <li key={v.name}>
              {v.name} <b>&asymp; {(v.size / (1024 * 1024)).toFixed(2)} MB</b>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}

export default OversizeModal
